import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from '../home/home.service';
import { ChangePasswordRequest } from '../model/change-password-request.model';
import { ForgotPasswordResponse } from '../model/forgot-password-response.model';
import { UserInfo } from '../model/user-info.model';
import { AccountService } from '../services/account.service';
import { confirmPassword } from '../shared/validators/confirm-password.validator';
import { TeacherService } from '../teacher/teacher.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  safeAvatarSVG: SafeHtml;
  changePwdForm: FormGroup;
  responsiveVoiceCancelInterval: number | undefined;
  teacherInfo: UserInfo;
  userProfileInfo: UserInfo;
  showConnectedTeacher: boolean = false
  isStudentProfile: boolean = false
  isChangePassword: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private route : Router,
    private toast: ToastrService,
    private homeService: HomeService,
    private teacherService: TeacherService,
    private accountService: AccountService
  ) { 
    this.changePwdForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      cnfrmPassword: ['', Validators.required],
    },{
      validator: [confirmPassword('newPassword', 'cnfrmPassword')]
    });
  }
  get changePwd() { return this.changePwdForm.controls; }
  ngOnInit(): void {
    setTimeout(() => {
      this.safeAvatarSVG = this.homeService.getAvatarImage();
    }, 500);

    this.responsiveVoiceCancelInterval = this.homeService.disableResponsiveVoice();
    let loggedInUserInfo = JSON.parse(localStorage.getItem("avatarUser"));
    this.teacherService.getTeacherById(loggedInUserInfo.teacherId).subscribe((teacherUserInfo: UserInfo) => {
      //console.log(teacherUserInfo);
      this.teacherInfo = teacherUserInfo;
    });
    this.teacherService.getUserById(loggedInUserInfo.userId).subscribe((userProfileInfo: UserInfo) => {
      this.userProfileInfo = userProfileInfo;
    });
    if (loggedInUserInfo.userType == "STUDENT" && loggedInUserInfo.status == "CONNECTED"){
      this.isStudentProfile = true;
      this.showConnectedTeacher = true;
    }
  }

  ngOnDestroy() {
    this.homeService.enableResponsiveVoice(this.responsiveVoiceCancelInterval);
  }


  goToAvatarCreationPage(){
    this.route.navigate([`/profile/avatarCreation`])
  }

  backToHome(){
    this.route.navigate([`/`]);
  }

  changePassword(){
    this.isChangePassword = !this.isChangePassword;
  }

  onSubmitChangePwd(formValue) {
    if(formValue.invalid){
      return; 
    }
    let loggedInUserInfo = JSON.parse(localStorage.getItem("avatarUser"));
    const payload: ChangePasswordRequest = {
      resetPasswordToken: loggedInUserInfo.userId,
      currentPassword: formValue.oldPassword,
      newPassword: formValue.newPassword,
      confirmPassword: formValue.confirmPassword
    };
    //console.log(payload);
    this.accountService.changePassword(payload)
      .subscribe((response : ForgotPasswordResponse) => {
        //console.log(response);
        if(response.statusCode == "INTERNAL_SERVER_ERROR"){
          this.toast.error(response.message);
        }else if(response.statusCode == "OK"){
          this.toast.success(response.message);
          this.isChangePassword = !this.isChangePassword; 
        }
      });
  }

}
